import { render, staticRenderFns } from "./footer.html?vue&type=template&id=4c8b636c&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=4c8b636c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b636c",
  null
  
)

export default component.exports